
var touch = false, clickEv = 'click';

/* Handle detect platform */
function handleDetectPlatform(){$.support.touch="ontouchend"in document,$.support.touch?(touch=!0,$("body").addClass("touch"),clickEv="touchstart"):($("body").addClass("notouch"),-1!=navigator.appVersion.indexOf("Mac")&&(navigator.userAgent.indexOf("Safari")>-1?$("body").addClass("macos"):navigator.userAgent.indexOf("Chrome")>-1?$("body").addClass("macos-chrome"):navigator.userAgent.indexOf("Mozilla")>-1&&$("body").addClass("macos-mozilla")))}

/* Fucntion get width browser */
function getWidthBrowser(){var e;return"number"==typeof window.innerWidth?e=window.innerWidth:document.documentElement&&(document.documentElement.clientWidth||document.documentElement.clientHeight)?e=document.documentElement.clientWidth:document.body&&(document.body.clientWidth||document.body.clientHeight)&&(e=document.body.clientWidth),e}
                                               
/* Handle dropdown box */
function handleDropdown(){$(".dropdown-toggle").length&&$(".dropdown-toggle").parent().hover(function(){0==touch&&getWidthBrowser()>767&&$(this).find(".dropdown-menu").stop(!0,!0).slideDown(300)},function(){0==touch&&getWidthBrowser()>767&&$(this).find(".dropdown-menu").hide()}),$("nav .dropdown-menu").each(function(){$(this).find("li").last().addClass("last")}),$(".dropdown a.a-in").on("click",function(){if(0==touch&&getWidthBrowser()>767){var o=$(this).attr("href");window.location=o}}),$(".cart-link").on("click",function(){if(0==touch&&getWidthBrowser()>767){var o=$(this).find(".dropdown-link").attr("href");window.location=o}})}

/* Log-in Dropdown */
function handleLogin(){$("#loginBox input").focus(function(){$(this).parents("#loginBox").addClass("focus")}).blur(function(){$(this).parents("#loginBox").removeClass("focus")})}
 
// handle Animate
function handleAnimate(){$("[data-animate]").each(function(){var a=$(this),t=$(this).attr("data-delay"),n=0;if(n=t?Number(t):200,!a.hasClass("animated")){a.addClass("not-animated");var e=a.attr("data-animate");a.appear(function(){setTimeout(function(){a.removeClass("not-animated").addClass(e+" animated")},n)},{accX:0,accY:-100},"easeInCubic")}})}     
      
      
/* Function update scroll product thumbs */
function updateScrollThumbsQS(){$("#gallery_main_qs").length&&($("#quick-shop-image .fancybox").on(clickEv,function(){var a=[],i=0,t=$("#gallery_main_qs .image-thumb");return t.each(function(t,e){a.push({href:e.href,title:e.title}),$(this).hasClass("active")&&(i=t)}),$.fancybox(a,{closeBtn:!0,index:i,helpers:{buttons:{}}}),!1}),$("#quick-shop-image").on(clickEv,".image-thumb",function(){var a=$(this),i=$(".product-image .main-image .main-image-bg"),t=a.parents(".product-image-wrapper"),e=a.attr("data-image-zoom"),n=a.attr("data-image");return i.show(),t.find(".image-thumb").removeClass("active"),a.addClass("active"),t.find(".main-image").find("img").attr("data-zoom-image",e),t.find(".main-image").find("img").attr("src",n).load(function(){i.hide()}),!1}))}                                                                  
      
// handle scroll-to-top button
function handleScrollTop(){function o(o){var l=$("#scroll-to-top");l.removeClass("off on"),l.addClass("on"==o?"on":"off")}$(window).scroll(function(){var l=$(this).scrollTop(),n=$(this).height();if(l>0)var t=l+n/2;else var t=1;o(1e3>t&&n>t?"off":"on")}),$("#scroll-to-top").click(function(o){o.preventDefault(),$("body,html").animate({scrollTop:0},800,"swing")})}  
      
function autocompleteSearch(){
  var currentAjaxRequest = null;  
  var searchForms = $('form[action="/search"]').css('position','relative').each(function() {    
    var input = $(this).find('input[name="q"]');    
    var offSet = input.position().top + input.innerHeight();
    $('<ul class="search-results"></ul>').css( { 'position': 'absolute', 'right': '0px', 'top': offSet } ).appendTo($(this)).hide();    
    input.attr('autocomplete', 'off').bind('keyup change', function() {
      var term = $(this).val();
      var form = $(this).closest('form');
      var searchURL = '/search?type=product&q=' + term;
      var resultsList = form.find('.search-results');      
      if (term.length > 3 && term != $(this).attr('data-old-term')) {      
        $(this).attr('data-old-term', term);      
        if (currentAjaxRequest != null) currentAjaxRequest.abort();     
        currentAjaxRequest = $.getJSON(searchURL + '&view=json', function(data) {          
          resultsList.empty();          
          if(data.results_count == 0) {          
            resultsList.hide();
          } else {         
            $.each(data.results, function(index, item) {
              var link = $('<a></a>').attr('href', item.url);
              link.append('<span class="thumbnail"><img src="' + item.thumbnail + '" /></span>');
              link.append('<span class="title">' + item.title + '</span>');
              link.wrap('<li></li>');
              resultsList.append(link.parent());
            });      
            if(data.results_count > 10) {
              resultsList.append('<li><span class="title"><a href="' + searchURL + '">See all results (' + data.results_count + ')</a></span></li>');
            }
            resultsList.fadeIn(200);
          }        
        });
      }
    });
  });
  $('body').bind('click', function(){
    $('.search-results').hide();
  });
}
   
/* Handle product quantity */
function handleQuantity(){$(".quantity-wrapper").length&&($(".quantity-wrapper").on(clickEv,".qty-up",function(){var a=$(this),t=a.data("src");$(t).val(parseInt($(t).val())+1)}),$(".quantity-wrapper").on(clickEv,".qty-down",function(){var a=$(this),t=a.data("src");parseInt($(t).val())>1&&$(t).val(parseInt($(t).val())-1)}))}
      
/* Handle Map with GMap */
function handleMap(){
  if(jQuery().gMap){
    if($('#contact_map').length){
      $('#contact_map').gMap({
        zoom: 17,
        scrollwheel: true,
        maptype: 'ROADMAP',
        markers:[
          {
            address: '474 Ontario St Toronto, ON M4X 1M7 Canada',
            html: '_address'
          }
        ]
      });
    }
  }
}      
            
$(window).ready(function($) { 
  handleDetectPlatform(); 
   autocompleteSearch()      
  updateScrollThumbsQS();  
  handleDropdown();  
  handleLogin();    
  $('[data-toggle="tooltip"]').tooltip();      
  handleQuantity();    
  handleScrollTop();  
  handleMap();
});
      
$(window).load(function() {
  $("#loading-div").addClass("fadeOut animated");
  $("#loading-div").fadeOut(800);    
  if ($(window).innerWidth() >= 768){ }
});
